import { App } from '@ps20-frontend/frontend-models';
import type { TgvOfferKind } from '../../app/angebot/angebot.models';
import { IAppState } from '../appState';
import { selectableChildKeys, tierName } from '../models/angebotOffers';
import { keepsPricingIssueKey } from '../models/pricingIssue';
import { TgvPricingIssueKind } from '../tgvActions';

export interface TgvPricingIssueOffer {
  key: string;
  kind: TgvOfferKind;
  name: string | null;
  errorCode: string | null;
}

export interface TgvPricingIssueView {
  kind: TgvPricingIssueKind;
  offers: TgvPricingIssueOffer[];
}

const THH_OFFER_KINDS: Record<string, TgvOfferKind> = {
  [App.THH_HUND]: 'THH_HUND',
  [App.THH_PFERD]: 'THH_PFERD',
};

const offerKindOf = (key: string): TgvOfferKind => THH_OFFER_KINDS[key] ?? 'TKV';

const animalNameOf = (state: IAppState, key: string): string | null => {
  const { tiergruppe } = state;
  const animal = tiergruppe.tiere.find(
    candidate => tiergruppe.angebotsIds[candidate.cardId] === key,
  );
  return animal ? tierName(tiergruppe, animal) : null;
};

export const selectPricingIssue = (state: IAppState): TgvPricingIssueView | null => {
  const issue = state.transientState.pricingIssue;
  if (!issue) {
    return null;
  }
  const { pricing } = state.transientState;
  const offers = selectableChildKeys(state.tiergruppe, state.transientState)
    .filter(
      key => issue.keys.includes(key) && keepsPricingIssueKey(issue.kind, pricing[key]?.status),
    )
    .map(key => {
      const kind = offerKindOf(key);
      return {
        key,
        kind,
        name: kind === 'TKV' ? animalNameOf(state, key) : null,
        errorCode: issue.errorCodes[key] ?? null,
      };
    });
  return offers.length === 0 ? null : { kind: issue.kind, offers };
};
